// extracted by mini-css-extract-plugin
export default {"alert":"FormAlert_alert__wqPUv"};